import {FC} from 'react';
import {createRoot} from 'react-dom/client';
import {ThemeProvider, styled} from 'styled-components';

import {IS_RUNNING_LOCALLY, MAVISMART_FRONTEND_URL} from '@shared/env';

import {CssReset} from '@shared_web/components/core/css_reset';
import {GlobalStyle} from '@shared_web/components/core/global_styles';
import {Modal} from '@shared_web/components/core/modal';

import {App} from '@mavismart_frontend/components/app';
import {registerChartJs} from '@mavismart_frontend/lib/chartjs';
import {initStores} from '@mavismart_frontend/lib/init_reset_store';
import {useAppTheme} from '@mavismart_frontend/theme';

if (IS_RUNNING_LOCALLY) {
  new EventSource(`${MAVISMART_FRONTEND_URL}/esbuild`).onmessage = () => location.reload();
}

const Root: FC = () => {
  const theme = useAppTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssReset />
      <PageContainer>
        <Modal />
        <App />
      </PageContainer>
      <GlobalStyle />
    </ThemeProvider>
  );
};
Root.displayName = 'Root';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');
  if (container) {
    initStores();
    createRoot(container).render(<Root />);
  }
});
registerChartJs();

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  height: 100%;
`;
